/* global gsap */
// import {ScrollTrigger} from 'gsap/ScrollTrigger';
// gsap.registerPlugin(ScrollTrigger);

export default class AnimatedWidth {
	constructor(element) {
		if (!element) return;

		gsap.to(element,
			{
				width: '100%',
				ease: "none",
				scrollTrigger: {
					trigger: element,
					start: "top bottom-=50px",
					end: "top center",
					markers: false,
					scrub: true
				}
			}
		);
	}
}
